import { createTypes, createActions, createReducer, assignLeft } from './util'
import _ from 'lodash/fp'

const namespace = 'signup'

const typeKeys = [
  'RESET',
  'SIGNUP_REQUEST',
  'SIGNUP_SUCCESS',
  'SIGNUP_ERROR',
  'UPDATE'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

function createSelectors () {
  const getError = _.get(`${namespace}.error`)
  const getLoading = _.get(`${namespace}.loading`)
  return {
    getError,
    getLoading
  }
}

export const selectors = createSelectors()

export const initialState = {
  errorFindingMode: false,
  loading: false,
  success: false,
  error: null,
  name: '',
  email: '',
  password: '',
  newsletter: true
}

const reducer = {
  [types.RESET]: p => _.constant(initialState),
  [types.SIGNUP_REQUEST]: p => assignLeft({ loading: true, success: false, error: null }),
  [types.SIGNUP_SUCCESS]: p => assignLeft({ loading: false, success: true, error: null }),
  [types.SIGNUP_ERROR]: p => assignLeft({ loading: false, success: false, error: _.get('error', p) }),
  [types.UPDATE]: assignLeft
}

export default createReducer(initialState, reducer)
